import { render, staticRenderFns } from "./BatchTop.vue?vue&type=template&id=3bafca48&"
import script from "./BatchTop.vue?vue&type=script&lang=js&"
export * from "./BatchTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports